export default __webpack_public_path__ + "assets/pdf/AdityaSWE_2023grad.pdf";